export const RULE_TYPE_COLOR_ORDER = {
  // Critical / loss
  daily_loss_exceeded: 1,
  max_loss_per_day: 1,
  manual_lockout: 1,
  position_loss_exceeded: 2,
  max_loss_per_position: 2,

  // Cool-down / pause (bluish blue — not alarm red)
  consecutive_loss_cooldown: 4,

  // Positive / target
  profit_target_per_day: 3,

  // Missing stop — pinkish red
  trade_without_stop_loss: 5,
  require_stop_loss: 5,

  // Outside window — orange
  outside_trading_window: 6,
  trading_window: 6, // legacy

  // Other
  max_trades_per_day: 7,
  max_risk_per_trade: 8,

  // Deviation-only (generally muted)
  stop_loss_modified: 90,
  profit_target_modified: 90,
};

export function getRuleTypeColor(ruleType, colors) {
  if (!ruleType) return colors.textMuted;

  switch (ruleType) {
    case 'daily_loss_exceeded':
    case 'max_loss_per_day':
    case 'manual_lockout':
      return colors.danger || colors.chartDown;

    case 'consecutive_loss_cooldown':
      // Bluish blue — pause/cooldown, not a hard loss alarm
      return '#3B82F6';

    case 'profit_target_per_day':
      return colors.success || colors.chartUp || colors.primary;

    case 'position_loss_exceeded':
    case 'max_loss_per_position':
      return colors.warning;

    case 'trade_without_stop_loss':
    case 'require_stop_loss':
      // Pinkish red
      return '#E85A8C';

    case 'outside_trading_window':
    case 'trading_window':
      // Orange
      return colors.warning || '#F59E0B';

    case 'max_trades_per_day':
      return colors.primary;

    case 'max_risk_per_trade':
      return colors.primaryLight || colors.primary;

    case 'stop_loss_modified':
    case 'profit_target_modified':
      // Should not look disabled/grey — these are still important deviations.
      return colors.text;

    default:
      return colors.textMuted;
  }
}

export function getRuleTypeOrder(ruleType) {
  return RULE_TYPE_COLOR_ORDER[ruleType] ?? 50;
}

